"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
const core_1 = require("@material-ui/core");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const CheckIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CheckIcon"));
const ChevronRightIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronRightIcon"));
const SpacerIcon_1 = __importDefault(require("@opsbase/web-icons/icons/SpacerIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Highlight_1 = __importDefault(require("../Highlight"));
const Text_1 = __importDefault(require("../Text"));
const makeMyClasses = () => ({
    root: {
        color: lib_palette_1.default.Liquorice.main,
        fontSize: 14,
        minHeight: 36,
        lineHeight: '36px',
        transition: 'background 0.1s, border 0.1s',
        ['&:hover']: {
            backgroundColor: lib_palette_1.default.secondary.background,
        },
    },
    warn: {
        color: lib_palette_1.default.CoralRed.main,
    },
    selected: {
        color: lib_palette_1.default.secondary.contrastText,
        backgroundColor: lib_palette_1.default.secondary.light + ' !important',
    },
});
exports.MenuItem = (0, react_1.forwardRef)((props, ref) => {
    const { classes, maxWidth = 180, warn, link, target, icon, label, color, highlight, selected, children, value, variant, leftTick = false, showTick = false, showTicking = false, showUnticking = false, showChevron = false, onClick, onMouseEnter, disabled = false, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [], classes);
    const rootClassName = (0, web_css_1.cx)(myCss.root, selected ? myCss.selected : '', warn ? myCss.warn : '');
    const ellipsisNeeded = {
        maxWidth,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    };
    const tickBit = (0, react_1.useMemo)(() => {
        if (showTick)
            return react_1.default.createElement(CheckIcon_1.default, { size: 16, color: lib_palette_1.default.secondary });
        if (showTicking)
            return react_1.default.createElement(CheckIcon_1.default, { style: { opacity: 0.2 }, size: 16, color: lib_palette_1.default.positive });
        if (showUnticking)
            return react_1.default.createElement(CheckIcon_1.default, { style: { opacity: 0.2 }, size: 16, color: lib_palette_1.default.error });
        if (leftTick && !showTick && !showTicking && !showUnticking)
            return react_1.default.createElement(SpacerIcon_1.default, { size: 16 });
        return null;
    }, [leftTick, showTick, showTicking, showUnticking]);
    const renderMenu = (react_1.default.createElement(core_1.MenuItem, { ref: ref, value: value, disabled: disabled, selected: selected, className: rootClassName + ' newStyle', onMouseEnter: onMouseEnter, onClick: onClick },
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, style: { maxWidth: '100%' } },
            leftTick && tickBit,
            icon,
            children,
            label && (react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement(Text_1.default, { color: color, variant: variant, style: ellipsisNeeded },
                    react_1.default.createElement(Highlight_1.default, { search: highlight }, label)))),
            showChevron && react_1.default.createElement(ChevronRightIcon_1.default, null),
            !leftTick && tickBit)));
    return link && !disabled ? (react_1.default.createElement(react_router_dom_1.Link, { style: { textDecoration: 'none' }, to: link || '#', target: target }, renderMenu)) : (renderMenu);
});
exports.default = exports.MenuItem;
